import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  $('.dropdown-menu__link--delete-quote').on('click', function (e) {
    const { deleteUrl } = $(e.target).data();
    $('#modal--delete-confirmation--quote').modal();
    $('#modal--delete-confirmation--quote .d-button--confirm-delete').attr('href', deleteUrl);

    return false;
  });
});
